<script lang="ts">
  // No plate: at chip height a plate shrinks the logo past reading.
  import BotIcon from "@lucide/svelte/icons/bot";
  import { BRAND_MARKS, type BrandMarkId } from "$lib/components/brand/brand-marks.js";

  let { mark, name, size = 14 }: { mark?: BrandMarkId; name: string; size?: number } = $props();
  const uid = $props.id();
  const svg = $derived(mark ? BRAND_MARKS[mark].svg.replace(/(id="|url\(#)([^")]+)/g, `$1$2-${uid}`) : "");
</script>

<span
  class="inline-grid shrink-0 self-center place-items-center text-content [&>svg]:size-full"
  style:width="{size}px"
  style:height="{size}px"
  role="img"
  aria-label={mark ? name : "Outside bot"}
  title={mark ? `Runs on ${name}` : "Runs outside Cyborg"}
  data-testid="external-bot-mark"
  data-mark={mark ?? "generic"}
>
  {#if mark}
    <!-- eslint-disable-next-line svelte/no-at-html-tags -- static, first-party constants from brand-marks.ts -->
    {@html svg}
  {:else}
    <BotIcon class="text-content-dim" strokeWidth={2} />
  {/if}
</span>
